import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'scaffold-paginate-page-select',
    templateUrl: './paginate-page-select.component.html',
    styleUrls: ['./paginate-page-select.component.scss'],
    standalone: false
})
export class PaginatePageSelectComponent implements OnInit {
  @Input() perPageOptions = [{ count: 10 }, { count: 25 }, { count: 50 }];
  @Input() perPage;
  @Input() countLabel;
  @Output() perPageChange: EventEmitter<number> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  setPageCount() {
    this.perPageChange.emit(this.perPage);
  }
}
